import { fetchClient } from "@babackapp/private-api-client/generated/client";
import { useQuery } from "@tanstack/react-query";

export type ProductRecommendationSource = {
  sourceId: string;
  count: number;
  productTitle: string | null;
  imageUrl: string | null;
};

type SourcesParams = {
  shopId: string;
  pairType?: "same_order" | "customer_history";
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const untypedGet = fetchClient.GET as unknown as (
  url: string,
  init: { params: { query: Record<string, string | undefined> } },
) => Promise<{
  data: ProductRecommendationSource[] | undefined;
  error: unknown;
}>;

export function useProductRecommendationSources(params: SourcesParams) {
  return useQuery({
    queryKey: ["product-recommendation-sources", params],
    enabled: !!params.shopId,
    queryFn: async () => {
      const { data, error } = await untypedGet(
        "/internal/product-recommendations/sources",
        {
          params: {
            query: {
              shopId: params.shopId,
              pairType: params.pairType,
            },
          },
        },
      );
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 60_000,
  });
}
